import { SimpleEnvBase } from "../EnvBase";
import manifest from "./polyfazer-manifest.json";

export class PolyfazerEnv extends SimpleEnvBase(manifest) {

	/**
	 *  @override
	 */
	get environmentGroup() {
		return "polyfazer";
	}
}

new PolyfazerEnv();
